import type { LimitAndSortDescription } from "@smartsuite/automation-engine-api";
import { NumberInputField } from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { CaptionBlock } from "../../../../../../../../components/CaptionBlock";
import { FIND_RECORDS_LIMIT } from "../../../../../../../../utils/constants";
import { StyledReactSelectFieldContainer } from "../../../../SelectEditor/InputSelectStyles";

export const LimitInput = observer<{
  limit: number;
  limitAndSortData: LimitAndSortDescription;
  onChange: (value: string) => void;
}>(({ limit, limitAndSortData, onChange }) => {
  const [focus, setFocus] = useState<boolean>(false);
  return (
    <StyledReactSelectFieldContainer>
      <CaptionBlock
        description={{
          label: t(`caption.find-number-records`, {
            limit: FIND_RECORDS_LIMIT,
          }),
          subLabel: "",
          icon: "",
          dynamic: false,
        }}
      />
      <NumberInputField
        placeholder="Limit"
        value={limit.toString()}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        state={focus ? "active" : undefined}
        onChangeValue={(value: string) =>
          !Number.isNaN(Number(value)) && onChange(value)
        }
        max={limitAndSortData.limitMax}
        min={limitAndSortData.limitMin}
        inputStyles={{
          backgroundColor: "white",
          borderColor: "G-1-5",
          borderHoverColor: "G-3",
          borderFocusColor: "G-3",
          height: 36,
        }}
        autoHideNavigation={true}
        showSymbol={false}
      />
    </StyledReactSelectFieldContainer>
  );
});
